import { Component, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule , isPlatformBrowser } from '@angular/common';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

@Component({
  selector: 'dx-origence-legal',
  templateUrl: './origence-legal.component.html',
  styleUrls: ['./origence-legal.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedUiLibraryModule]
})
export class OrigenceLegalComponent {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  public print(): void {
    if (this.isBrowser) {
      window.print();
    }
  }
}
